import DataQualityResult from "models/DataQualityResult";

class DataQualityResultsCollection extends Backbone.Collection {}

DataQualityResultsCollection.prototype.model = DataQualityResult;

export default DataQualityResultsCollection;



// WEBPACK FOOTER //
// ./app/models/DataQualityResultsCollection.js